import { Component, EventEmitter, Output, OnDestroy } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Component({
    selector: 'delete-model',
    templateUrl: './deletemodel.component.html',
    styleUrls: ['./deletemodel.component.css']
  })
  export class DeleteModelComponent implements OnDestroy {

    modelToDelete: any = [];
    deleteSpinnerIcon = '';
    private projectsUrl = globals.APIURL + '/projects';

    modalDeleteModalAction = new EventEmitter<string | MaterializeAction>();
    @Output() DeleteCompleteAction = new EventEmitter();

    constructor(private http: Http, public authHttp: AuthHttp) { }

    ngOnDestroy() {
      this.modalDeleteModalAction.emit({ action: 'modal', params: ['close'] });
    }

    openModalDeleteModel(model: any) {
        this.modelToDelete = model;
        this.deleteSpinnerIcon = '';
        this.modalDeleteModalAction.emit({ action: 'modal', params: ['open'] });
    }

    deleteModel(modelID: Number) {
        this.deleteSpinnerIcon = 'fa right fa-spinner fa-pulse';
        this.deleteModelTask(modelID)
        .subscribe(
        data => {
            console.log('data : ', data);
            this.modalDeleteModalAction.emit({ action: 'modal', params: ['close'] });
            this.DeleteCompleteAction.emit();
        },
        error => {
            console.log('data : ', error);
        }
        );
    }

    deleteModelTask(id: any): Observable<string> {
        console.log('deleteProject service method called');

        let deleteUrl = this.projectsUrl + '/' + id;
        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: '', headers: headers });
        // console.log('URL =>', deleteUrl);
        // console.log('OPTIONS =>', options);

        return this.authHttp.delete(deleteUrl, options)
          .map(this.extractData)
          .catch(this.handleError);
      }

      private extractData(res: Response) {
        let body = res.json();
        // console.log('BODY:', body);
        return body || {};
      }

      handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
          error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
        return Observable.throw(errMsg);
      }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/deletemodel/deletemodel.component.ts